import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=1ca9ba38"
import script from "./Subtitles.vue?vue&type=script&lang=js"
export * from "./Subtitles.vue?vue&type=script&lang=js"
import style0 from "./Subtitles.vue?vue&type=style&index=0&id=1ca9ba38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports